// import { DIC } from "@/const/dic";
const pass = (rule, value, callback) => {
  if (value) {
    callback();
  } else {
    callback();
  }
};

export const appointmentCardOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  index: false,
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  menuWidth: "260",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "预约卡ID",
      prop: "id",
      hide: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "店铺名称",
      prop: "shopName",
      addVisdiplay: false,
      type: "input",
      width: "240",
    },
    {
      label: "经销商",
      prop: "agency",
      hide: true,
      solt: true,
      formsolt: true,
      search: true,
      span: 24,
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: pass,
          message: "经销商必须选择",
        },
      ],
    },
    {
      type: "input",
      label: "数量",
      hide: true,
      prop: "num",
      span: 24,
      rules: [
        {
          required: true,
          trigger: "blur",
          message: "数量必须填写",
        },
      ],
    },
    /*  {
      type: "select",
      label: "打印类型",
      prop: "printType",
      hide: true,
      dicData: [
        // {
        //   label: "A6纸模版",
        //   value: "A6",
        // },
        {
          label: "A4纸模版(只能分配双数的预约卡)",
          value: "A4",
        }
      ],
      span: 24,
      // display: true,
      props: {
        label: "label",
        value: "value",
        desc: "desc",
      },
      rules: [
        {
          required: true,
          trigger: "blur",
          message: "打印类型必须选择",
        },
      ],
    }, */
    {
      label: "打印类型",
      prop: "printType",
      hide: true,
      type: "radio",
      dicData: [
        {
          label: "A4纸模版(只能分配双数的预约卡)",
          value: "A4",
        },
      ],
      valueDefault: "A4",
      disabled: true,
      props: {
        label: "label",
        value: "value",
        desc: "desc",
      },
      rules: [
        {
          required: true,
          trigger: "blur",
          message: "打印类型必须选择",
        },
      ],
    },
    {
      type: "input",
      label: "服务热线",
      span: 24,
      // display: true,
      hide: true,
      prop: "serviceHotLine",
      formsolt: true,
    },
    {
      label: "联系人",
      prop: "name",
      type: "input",
      width: "110",
      search: true,
      addVisdiplay: false,
      editVisdiplay: false,
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: pass,
        },
      ],
    },
    {
      label: "联系人电话",
      prop: "mobile",
      search: true,
      type: "input",
      addVisdiplay: false,
      editVisdiplay: false,
      width: "200",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: pass,
        },
      ],
    },
    {
      label: "已发纸质卡数",
      prop: "total",
      width: "110",
      type: "input",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "未使用纸质卡数",
      prop: "unused",
      width: "150",
      type: "input",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "已使用纸质卡数",
      prop: "used",
      width: "150",
      type: "input",
      addVisdiplay: false,
      editVisdiplay: false,
    },
  ],
};
